export default __webpack_public_path__ + "static/media/Boots of Bedlam.414b0e54.jpg";